import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import {SITE_SERVICES} from './metricsModels';


const metricsConsoleErrorHandler = (err: Error) => console.error(err);
let stage = 'beta';
const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
    // if (process.env.NODE_ENV === 'test') {
    //     const metricsDriver = new KatalMetricsDriverArrayCollector();
    //     //  Attach to global window object so tests can see it
    //     (window as any).metricsDriver = metricsDriver;
    //     return metricsDriver;
    // } 
    if (stage?.toLowerCase() === 'prod') {
        return new KatalMetricsDriverSushi.Builder()
            .withDomainRealm('prod', 'USAmazon')
            .withErrorHandler(metricsConsoleErrorHandler)
            .build();
    } else {
        // return new KatalMetricsDriverConsoleLogJson();
        const metricsDriver = new KatalMetricsDriverArrayCollector();
        //  Attach to global window object so tests can see it
        (window as any).metricsDriver = metricsDriver;
        return metricsDriver; 
    }
};

const makePublisher = (): KatalMetrics.Publisher => {
    stage = (stage === 'dev' ? 'BETA' : stage?.toUpperCase())
    const metricsDriver = makeMetricsDriver();
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite(`ATEAM-AccountingCentral-${stage}`)
        .withServiceName(SITE_SERVICES.ACCOUNTING_BI_CENTRAL)
        .build();
    return new KatalMetrics.Publisher(
        metricsDriver,
        metricsConsoleErrorHandler,
        initialMetricsContext);
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
